<script setup lang="ts">
import NxSwitch from '../Inputs/NxSwitch.vue';

defineProps<{
  label: string;
  disabled?: boolean;
}>();

const model = defineModel<boolean>({ required: true });
</script>

<template>
  <label class="nx-settings-toggle" :class="{ disabled }">
    <span class="nx-settings-toggle-label">
      {{ label }}
      <slot />
    </span>
    <NxSwitch v-model="model" :disabled="disabled" height="xs" />
  </label>
</template>

<style scoped>
.nx-settings-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--nxt-space-sm);
  min-height: var(--nxt-control-size-sm);
  padding: var(--nxt-space-2xs) var(--nxt-space-2xs) var(--nxt-space-2xs) var(--nxt-space-xs);
  border: var(--nxt-hairline) solid var(--nxt-border);
  border-radius: var(--nxt-radius-sm);
  cursor: pointer;
}

.nx-settings-toggle.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.nx-settings-toggle-label {
  color: var(--nxt-fg);
  font-size: var(--nxt-font-size-sm);
  line-height: 1.3;
}

.nx-settings-toggle :deep(.switch-wrapper) {
  flex: 0 0 auto;
}
</style>
